import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ParadigmaModal from "../../../components/ParadigmaModal/ParadigmaModal.js";

import api from "../../../api";

import { Row, Col } from 'reactstrap';

import ParadigmaAsyncSeeker from "../../../components/ParadigmaAsyncSeeker/ParadigmaAsyncSeeker";
import ParadigmaLabeledInput from "../../../components/ParadigmaLabeledInput";
import ParadigmaEditor from '../../../components/ParadigmaEditor/ParadigmaEditor';

class Detail extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isOpen: false,
            descripcion: '',
            asunto: '',
            cuerpo: ''
        };
    }

    static propTypes = {
        id: PropTypes.func.isRequired,
    }

    resetForm() {
        this.setState({
            descripcion: '',
            asunto: '',
            cuerpo: ''
        });
    }

    setSelects(data) {
        this.setState(() => ({
            descripcion: data.descripcion,
            asunto: data.asunto,
            cuerpo: data.cuerpo
        }));
    }

    createMarkup = () => {
        return {__html: this.state.cuerpo};
    }

    render() {

        return (
            <ParadigmaModal
                getUrl={api.email.plantillas.detail}
                onSubmit={(e) => this.props.onSubmit(e)}
                id={this.props.id}
                missingIdMessage={"Debe seleccionar una fila."}
                title={"Plantilla de Mail"}
                buttonTitle={"Ver"}
                className={"modal-lg"}
                buttonIcon={"fa fa-search fa-lg"}
                saveButton={false}
                closeButton={true}
                onGotData={(data) => this.setSelects(data)}
                onClose={() => this.resetForm()}
            >
                <Row>
                    <Col>
                        <ParadigmaLabeledInput
                            label={"Descripción"}
                            fieldName={"descripcion"}
                            labelColumns={2}
                            fieldColumns={10}
                            value={this.state.descripcion}
                            disabled={true}
                        />
                    </Col>
                </Row>

                <Row>
                    <Col className="col-12 col-separator">Mail</Col>
                </Row>



                <Row>
                    <Col>
                        <ParadigmaLabeledInput
                            label={"Asunto"}
                            fieldName={"asunto"}
                            labelColumns={2}
                            fieldColumns={10}
                            value={this.state.asunto}
                            disabled={true}
                        />
                    </Col>
                </Row>

                <Row className="mx-0">

                    <Col className="col-12 px-0 my-2">Cuerpo</Col>
                    <Col className="px-0">

                        <ParadigmaEditor
                            value={this.state.cuerpo}
                            onChange={this.onCuerpoChange}
                            disabled
                        />

                    </Col>
                </Row>
            </ParadigmaModal>
        );
    }
}

export default Detail;



// WEBPACK FOOTER //
// ./src/views/Config/Plantillas/Detail.js